import Axios from 'axios';
import config from './config.service';
import {env} from '@/services/env.service';
import { useTheming } from '@odin/vue2-utils';
import store from '../store';
import { StoreActions } from '../store/const.enum';
import { setConfigValues, Theme } from '@odin/services';
import { nextTick } from 'vue';

const themes = import.meta.glob('../styles/themes/*/index.scss', {eager: false, query: '?inline'});
type DynamicThemeImportType = { default: string };

let themeStyleElm: Element | null;

const switchThemeLocal = async (theme: string) => {
  // eslint-disable-next-line no-console
  console.log('switchTheme', theme);

  // Load the theme CSS
  const themeImport = await themes[`../styles/themes/${theme}/index.scss`]() as DynamicThemeImportType;

  // Create the theme <style>
  if (!themeStyleElm) {
    themeStyleElm = Object.assign(
      document.createElement('style'),
      {
        id: 'theme-styles',
      }
    );
    document.head.appendChild(themeStyleElm);
  }

  // Apply the loaded styles
  themeStyleElm.innerHTML = themeImport.default;
};

const linkId = 'ws-theme-stylesheet';
const switchThemeRemote = async (theme: string) => {
  const {data: manifest} = await Axios.get(
    config.assetUrl + '/manifest.json'
  );

  let linkElm = document.getElementById(linkId);
  if (!linkElm) {
    linkElm = Object.assign(
      document.createElement('link'),
      {
        id: linkId,
        rel: 'stylesheet',
        'data-type': 'theming-link',
      });

    document.body.appendChild(linkElm);
  }

  linkElm.setAttribute(
    'href',
    config.assetUrl + '/' + manifest[`src/styles/themes/${theme}/index.scss`]['file']
  );
};

export const switchTheme = async (newTheme: Theme) => {
  config.theme = newTheme;
  store.dispatch('theme/' + StoreActions.SET_THEME, {theme: newTheme});
  setConfigValues(config);
  env.MODE === 'development' ? switchThemeLocal(newTheme) : await switchThemeRemote(newTheme);

  nextTick(() => {
    const { theme } = useTheming();

    theme.value = newTheme;
  });
};

if (env.MODE === 'development') {
  switchTheme(config.theme);
}

// @ts-ignore
window.switchTheme = switchTheme;
